<template>
  <b-container class="licitacoes">
    <h2 class="mb-4">Licitações Comunicados</h2>

    <div class="card-area" v-loading="loading">
      <div
        class="card-comunicado"
        v-for="item in comunicados.data"
        :key="item.id"
        @click="handleClick(item)"
        role="button"
        :aria-label="`Abrir comunicado: ${item.titulo}`"
      >
        <div class="card p-3 shadow-sm h-100">
          <h5 class="mb-0">{{ item.titulo }}</h5>
        </div>
      </div>
    </div>

    <div v-if="comunicados.total && !loading">
      <b-pagination
        align="center"
        v-model="comunicados.current_page"
        pills
        :total-rows="comunicados.total"
        :per-page="comunicados.per_page"
        @change="carregarPagina"
      ></b-pagination>
    </div>

    <b-modal v-model="modalShow" title="Detalhes" size="lg" hide-footer class="modal-limitada">
      <div>
        <h4>{{ modalData.titulo }}</h4>
        <div v-html="modalData.texto" class="mt-3 conteudo-texto"></div>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
export default {
  name: "LicitacoesComunicados",
  data() {
    return {
      comunicados: {
        data: [],
        current_page: 1,
        per_page: 15,
        total: 0
      },
      loading: false,
      modalShow: false,
      modalData: {
        titulo: "",
        texto: ""
      }
    };
  },
  methods: {
    async buscarComunicados(pagina = 1) {
      this.loading = true;
      window.scrollTo({ top: 0, behavior: "smooth" });
      try {
        const res = await this.$axios.get(`/v1/licitacoes-comunicados?page=${pagina}`);
        if (res.status === 200) {
          this.comunicados = res.data;
        }
      } catch (e) {
        console.error("Erro ao buscar comunicados", e);
      } finally {
        this.loading = false;
      }
    },
    carregarPagina(pagina) {
      this.buscarComunicados(pagina);
    },
    sanitizeHtml(html) {
      return (html || "")
        .replace(/margin-(left|right)\s*:\s*-?\d+(\.\d+)?pt;?/gi, "")
        .replace(/\sstyle="[^"]*"/gi, "")
        .replace(/\swidth="[^"]*"/gi, "");
    },
    normalizeUrl(url) {
      if (!url) return null;
      const trimmed = String(url).trim();
      if (!trimmed) return null;
      if (!/^https?:\/\//i.test(trimmed)) {
        return "https://" + trimmed.replace(/^\/+/, "");
      }
      return trimmed;
    },
    openInNewTab(url) {
      const w = window.open(this.normalizeUrl(url), "_blank", "noopener,noreferrer");
      if (w) w.opener = null;
    },
    handleClick(item) {
      if (item && item.url) {
        const normalized = this.normalizeUrl(item.url);
        if (normalized) {
          this.openInNewTab(normalized);
          return;
        }
      }
      this.modalData = {
        titulo: item.titulo,
        texto: this.sanitizeHtml(item.texto)
      };
      this.modalShow = true;
    }
  },
  mounted() {
    this.buscarComunicados();
  }
};
</script>

<style scoped lang="scss">
.licitacoes {
  padding: 30px 20px;
  background-color: var(--background-color-primary);
  font-family: Poppins;

  h2 {
    font-weight: bold;
    color: var(--color-text-title, #1f387f);
  }

  .card-area {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 30px;
  }

  .card-comunicado {
    flex: 1 1 calc(33.333% - 20px);
    min-width: 250px;
    max-width: 100%;
    cursor: pointer;

    .card {
      transition: all 0.3s ease;
      border-left: 5px solid #1f387f;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
      }

      h5 {
        color: #1f387f;
        font-size: 1rem;
        font-weight: 600;
      }
    }
  }

  @media (max-width: 768px) {
    .card-comunicado {
      flex: 1 1 100%;
    }
  }
}

.modal-limitada >>> .modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding-right: 15px;
}

.modal-limitada >>> .modal-dialog {
  max-width: 90vw;
}

.modal-limitada >>> .conteudo-texto {
  font-family: Poppins, sans-serif;
  font-size: 1rem;
  line-height: 1.6;
  color: #333;

  * {
    all: unset;
    display: block;
    margin-bottom: 1rem;
    max-width: 100%;
    word-break: break-word;
    white-space: normal;
    font-family: inherit;
    font-size: inherit;
    color: inherit;
    box-sizing: border-box;
  }

  a {
    text-decoration: underline;
    color: #1f387f;
  }

  h1, h2, h3, h4 {
    font-weight: bold;
    margin-top: 1.5rem;
  }
}
</style>
